import axios from 'axios';

// Use relative URL for API calls - this works with any domain (custom or default)
// The browser will automatically use the current domain
const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Handle redirects properly
  maxRedirects: 5,
  // Timeout largo para operaciones de generación de reportes grandes
  timeout: 300000, // 5 minutos
});

// Request interceptor para agregar el token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['X-Pagina'] = window.location.pathname;
    // Remove trailing slash to prevent 307 redirect issues in production
    if (config.url && config.url.endsWith('/')) {
      config.url = config.url.slice(0, -1);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // 503 por reconexión de la base: reintenta las lecturas (GET) hasta 2 veces.
    const cfg = error.config;
    if (
      cfg && error.response?.status === 503 &&
      error.response.headers?.['x-retryable'] === 'mongo' &&
      (cfg.method || 'get').toLowerCase() === 'get' &&
      (cfg._mongoRetry || 0) < 2
    ) {
      cfg._mongoRetry = (cfg._mongoRetry || 0) + 1;
      await new Promise((r) => setTimeout(r, 1500 * cfg._mongoRetry));
      return api(cfg);
    }
    // No forzar logout/redirect en llamadas de polling en segundo plano (ej. jobs de Waya),
    // así un 401 transitorio o expiración durante un proceso largo no deja la pantalla en blanco.
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
